import toastr from 'toastr';
import { createAppChat, getChannelInfoCommunityReach, getDMMessagesCommunityReach, getJoinedChannelsListCommunityReach, sendDMMessageCommunityReach, getChannelMembersInfoCommunityReach, getUserApi, getPrivateMessageApi, getChannelMembers, getLatestChatUsers, editDMMessageCommunityReach, deleteDMMessageCommunityReach } from '../../api';
import { ChatRoom } from '../../types/chat';
import { CANCEL_IS_EDIT_MESSAGE_CommunityReach, CHANNEL_MEMBERS, CHAT_MEMBERS, CREATE_CHANNEL_CommunityReach, CREATE_CHANNEL_CommunityReach_ERROR, CREATE_CHANNEL_CommunityReach_LOADING, DELETE_DIRECT_MESSAGE_CommunityReach, DELETE_MESSAGE_CommunityReach, GET_ACTIVE_MESSAGE, GET_CHANNEL_INFO_CommunityReach, GET_CHANNEL_INFO_ERROR_CommunityReach, GET_CHANNEL_MEMBER_INFO_ERROR, GET_CHAT_USERS_INFO_CommunityReach, GET_CHAT_USERS_INFO_ERROR_CommunityReach, GET_JOINED_CHANNELS_LIST_CommunityReach, GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach, GET_LATEST_CHAT_USER, GET_MESSAGES_CommunityReach, GET_MESSAGES_ERROR_CommunityReach, GET_PRIVATE_CHAT_INFO_CommunityReach, GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach, LAST_CHAT_ROOM, SEND_DIRECT_MESSAGE_CommunityReach, SEND_MESSAGE_CommunityReach, SET_ACTIVE_MESSAGE, SET_EDIT_MESSAGE, SET_ENTERED_TEXT_CommunityReach, SET_IS_EDIT_MESSAGE_CommunityReach, SET_MESSAGE_ID_CommunityReach, UPDATE_MESSAGE_LIST_SO_CommunityReach } from '../../types';




export const createAppChannel = (body: any) => {
    return async (dispatch: any) => {
        dispatch({ type: CREATE_CHANNEL_CommunityReach_LOADING });
        try {
            const res = await createAppChat(body);
            if (res) {
                dispatch({
                    type: CREATE_CHANNEL_CommunityReach,
                    payload: res,
                });
                toastr.success("Channel Created Successfully");
            }

        } catch (error) {
            dispatch({
                type: CREATE_CHANNEL_CommunityReach_ERROR,
                payload: error.message
            });
        }
    };
};

export const getActiveMessage = (messages: any) => {
    return async (dispatch: any) => {
        dispatch({
            type: GET_ACTIVE_MESSAGE,
            payload: messages,
        });
    }
}
export const setActiveMessage = (messages: any) => {
    return async (dispatch: any) => {
        dispatch({
            type: SET_ACTIVE_MESSAGE,
            payload: messages,
        });
    }
}
export const getChatMessagesCommunityReach = (roomId: string, offset: number = 0, count: number = 50) => {
    return async (dispatch: any) => {
        try {
            let endPoint: string;

            const res: any = await getDMMessagesCommunityReach({ room_id: roomId });
            if (res) {
                dispatch({
                    type: GET_MESSAGES_CommunityReach,
                    payload: res.slice().reverse()
                });
            }
        } catch (error) {
            dispatch({
                type: GET_MESSAGES_ERROR_CommunityReach,
                payload: error?.errorType,
            });
        }
    };
};


export const getLastChatUsers = (userId: string, offset: number = 0, count: number = 50) => {
    return async (dispatch: any) => {
        try {
            const res: any = await getLatestChatUsers(userId);
            if (res) {
                dispatch({
                    type: GET_LATEST_CHAT_USER,
                    payload: res
                });
            }
        } catch (error) {
            console.log('error', error)
        }
    };
};



export const sendDmMessageCommunityReach = (body: any) => {
    return async (dispatch: any) => {
        try {
            const response: any = await sendDMMessageCommunityReach(body);
            if (body['receiverId']) {

                console.log("Pbodudfifdi", body)
                dispatch({
                    type: SEND_DIRECT_MESSAGE_CommunityReach,
                    payload: response,
                });
            }
            else {
                dispatch({
                    type: SEND_MESSAGE_CommunityReach,
                    payload: response,
                });

            }


        } catch (error) {
            console.error(error)
        }
    };
};
export const sendDmMediaMessageCommunityReach = (body: any, messageType = "public") => {
    return async (dispatch: any) => {
        try {
            const response: any = await sendDMMessageCommunityReach(body)
            if (messageType == 'private') {
                dispatch({
                    type: SEND_DIRECT_MESSAGE_CommunityReach,
                    payload: response,
                });
            }
            else {
                dispatch({
                    type: SEND_MESSAGE_CommunityReach,
                    payload: response,
                });

            }


        } catch (error) {
            console.error(error)
        }
    };
};



export const editChatMessage = (body: any) => {
    return async (dispatch: any) => {
        try {
            await editDMMessageCommunityReach(body);
        } catch (error) {
            console.error(error)
        }
    };
};

export const deleteChatMessage = (messageId: string) => {
    return async (dispatch: any) => {
        try {
            let response: any = await deleteDMMessageCommunityReach(messageId);
            if (response?.receiverId) {
                dispatch({
                    type: DELETE_DIRECT_MESSAGE_CommunityReach,
                    payload: response,
                });
            }
            else {
                dispatch({
                    type: DELETE_MESSAGE_CommunityReach,
                    payload: response,
                });
            }
        } catch (error) {
            console.error(error)
        }
    };
};


export const getCommunityReachJoinedChannelList = (body: any) => {
    return async (dispatch: any) => {
        try {
            const res = await getJoinedChannelsListCommunityReach({ user_id: body?.user_id });

            if (res) {
                dispatch({
                    type: GET_JOINED_CHANNELS_LIST_CommunityReach,
                    payload: res,
                });
            }
            else {
                dispatch({
                    type: GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach,
                    payload: res,
                });
            }

        } catch (error) {
            console.error(error)
        }
    };
};

export const getCommunityReachChannelInfo = (roomId: string) => {
    return async (dispatch: any) => {
        try {

            const res = await getChannelInfoCommunityReach(roomId);

            if (res) {
                dispatch({
                    type: GET_CHANNEL_INFO_CommunityReach,
                    payload: res,
                });
            }
        } catch (error) {
            dispatch({
                type: GET_CHANNEL_INFO_ERROR_CommunityReach,
                payload: error?.errorType,
            });
        }
    };
};

export const getCommunityReachPrivateMessage = (senderId: string, receiverId: string) => {
    return async (dispatch: any) => {
        try {
            dispatch({ type: CREATE_CHANNEL_CommunityReach_LOADING });
            const res: any = await getPrivateMessageApi(senderId, receiverId); if (res) {
                dispatch({
                    type: GET_PRIVATE_CHAT_INFO_CommunityReach,
                    payload: res.data.slice().reverse()
                });
            }
        } catch (error) {
            dispatch({
                type: GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach,
                payload: error?.errorType,
            });
        }
    };
};

export const getCommunityReachUserInfo = (userId: string) => {
    return async (dispatch: any) => {
        try {
            const res = await getUserApi(userId);
            if (res) {
                dispatch({
                    type: GET_CHAT_USERS_INFO_CommunityReach,
                    payload: res.data,
                });
            }
        } catch (error) {
            dispatch({
                type: GET_CHAT_USERS_INFO_ERROR_CommunityReach,
                payload: error?.errorType,
            });
        }
    };
};


export const lastChatRoom = (payload: ChatRoom) => ({
    type: LAST_CHAT_ROOM,
    payload,
});



export const getCommunityReachChannelMembers = (roomId: string) => {
    return async (dispatch: any) => {
        try {
            dispatch({ type: CREATE_CHANNEL_CommunityReach_LOADING });
            const res: any = await getChannelMembers(roomId);
            const members = res.filter((data: any) => data['room_user_id']?.['name'])
            if (res) {
                dispatch({
                    type: CHANNEL_MEMBERS,
                    payload: members,
                });
            }
        } catch (error) {
            dispatch({
                type: GET_CHANNEL_MEMBER_INFO_ERROR,
                payload: error?.errorType,
            });
        }
    };
}

export const getChannelMembersInfoMEO = () => {
    return async (dispatch: any) => {
        try {

            const res = await getChannelMembersInfoCommunityReach();

            if (res) {
                dispatch({
                    type: CHAT_MEMBERS,
                    payload: res,
                });
            }
        } catch (error) {
            dispatch({
                type: GET_CHANNEL_MEMBER_INFO_ERROR,
                payload: error?.errorType,
            });
        }
    };
};




export const setMessageEdit = () => ({
    type: SET_IS_EDIT_MESSAGE_CommunityReach,
    payload: true,
});

export const cancelMessageEdit = () => ({
    type: CANCEL_IS_EDIT_MESSAGE_CommunityReach,
    payload: false,
});

export const setMessageId = (payload: string) => ({
    type: SET_MESSAGE_ID_CommunityReach,
    payload
})

export const setEnteredText = (payload: string) => ({
    type: SET_ENTERED_TEXT_CommunityReach,
    payload,
});

export const setEditMessageId = (payload: string) => ({
    type: SET_EDIT_MESSAGE,
    payload,
});

export const updateMessageListSoRc = (payload: any) => ({
    type: UPDATE_MESSAGE_LIST_SO_CommunityReach,
    payload,
});

export const addMessageRealtimeCommunityReach = (payload: any) => {
    return async (dispatch: any) => {
        try {
            if (payload) {
                if (payload?.senderId?._id != localStorage.getItem("user")) {
                    dispatch({
                        type: SEND_MESSAGE_CommunityReach,
                        payload: payload,
                    });
                }
            }
        } catch (error) {
            dispatch({
                type: GET_CHANNEL_INFO_ERROR_CommunityReach,
                payload: error?.errorType,
            });
        }
    };

}